import ReactGA from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';

// Extend window object to include gtag
declare global {
	interface Window {
		gtag: (...args: any[]) => void;
	}
}

// Initialize GA4 with default consent state (denied)
export const initializeGA4 = (measurementId: string) => {
	// Initialize GA4 with default consent state
	ReactGA.gtag('consent', 'default', {
		'ad_storage': 'denied',
		'analytics_storage': 'denied',
		'functionality_storage': 'denied',
		'personalization_storage': 'denied',
		'security_storage': 'granted' // Always granted
	});
	ReactGA.initialize(measurementId, {
		gtagOptions: {
			send_page_view: 'false',
		}
	});
};

// Update GA4 consent state
export const updateGA4Consent = (consent: boolean) => {
	ReactGA.gtag('consent', 'update', {
		'ad_storage': consent ? 'granted' : 'denied',
		'analytics_storage': consent ? 'granted' : 'denied',
		'functionality_storage': consent ? 'granted' : 'denied',
		'personalization_storage': consent ? 'granted' : 'denied',
		'security_storage': 'granted' // Always granted
	});
};

// Wrapper for ReactGA.event - no need to check consent as gtag handles it
export const trackGAEvent = (eventData: Parameters<typeof ReactGA.event>[0]) => {
	ReactGA.event(eventData);
};

// Wrapper for ReactGA.send - no need to check consent as gtag handles it
export const trackGAPageview = (pageData: Parameters<typeof ReactGA.send>[0]) => {
	ReactGA.send(pageData);
};

// Get cookie consent from localStorage
const getCookieConsent = (): boolean => {
	try {
		const consent = localStorage.getItem('cookieConsent');
		return consent === 'true';
	} catch {
		return false;
	}
};

// Wrapper for ReactPixel.track that checks cookie consent
export const trackPixelEvent = (eventName: string, parameters?: any) => {
	if (getCookieConsent()) {
		ReactPixel.track(eventName, parameters);
	}
};

// Wrapper for ReactPixel.trackCustom that checks cookie consent
export const trackPixelCustomEvent = (eventName: string, parameters?: any) => {
	if (getCookieConsent()) {
		ReactPixel.trackCustom(eventName, parameters);
	}
};
